export default __webpack_public_path__ + "static/media/MINERVAM.1042f6ff.OTF";